export default __webpack_public_path__ + "73a4f5ba6964d049e32683896a343b5e.png";